<div *ngIf="_gearAppService.GearMonitorLiterals && _gearAppService.GearMonitorLiterals && _appService.CoreCommonLiterals && facilitiesList">
  <div class="page-title">
    <div class="row align-items-center justify-content-between">
      <div class="col-auto">{{_gearAppService.GearCommonLiterals.Tanks}}</div>
      <div class="col-1">
        <button id="tanks-btn-collapsed" type="button" class="btn btn-primary float-right" (click)="sidebar.open()" aria-controls="filters">
          <i class="fa fa-filter"></i>
        </button>
      </div>
    </div>
  </div>

  <lib-sidebar #sidebar id="filters" [title]="_appService.CoreCommonLiterals.Filter" [invisibleBackdrop]="true">
    <div class="form-group">
      <label for="facilities">{{_appService.CoreCommonLiterals.Facilities}}</label>
      <ss-multiselect-dropdown
        [texts]="_multiSelectTexts" 
        [name]="facilities"
        id="facilities"
        #facilities{{i}}="ngModel"
        [settings]="_multiSelectSettings" 
        [options]="facilitiesList"
        (onAdded)="applyFilters()"
        (onRemoved)="applyFilters()"
        [(ngModel)]="facilities"
        [required]="facilities.length">
      </ss-multiselect-dropdown>
    </div>
    <div class="form-group">
      <label for="materials">{{_gearAppService.GearCommonLiterals.TanksContentMaterials}}</label> 
      <ss-multiselect-dropdown 
        [texts]="_multiSelectTexts" 
        [name]="materials"
        id="materials"
        [settings]="_multiSelectSettings" 
        [options]="materialsList"
        (onAdded)="applyFilters()"
        (onRemoved)="applyFilters()"
        [(ngModel)]="materials"
        [required]="materials.length">
      </ss-multiselect-dropdown>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox ">
        <input type="checkbox" 
          class="custom-control-input" 
          id="checkNormal" 
          value="checkNormal" 
          [(ngModel)]="checkNormal"
          (change)="applyFilters()">
        <label class="custom-control-label" for="checkNormal">{{_appService.CoreCommonLiterals.Normal}}</label>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" 
          class="custom-control-input" 
          id="checkInMaintenance" 
          value="checkInMaintenance"  
          [(ngModel)]="checkInMaintenance"
          (change)="applyFilters()">       
        <label class="custom-control-label" for="checkInMaintenance">{{_gearAppService.GearCommonLiterals.InMaintenance}}</label>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox ">
        <input type="checkbox" 
          class="custom-control-input" 
          id="checkAlert" 
          value="checkAlert" 
          [(ngModel)]="checkAlert"
          (change)="applyFilters()">
        <label class="custom-control-label" for="checkAlert">{{_appService.CoreCommonLiterals.Errors}}</label>
      </div>
    </div>
  </lib-sidebar>

  <div class="screen-container">
    <div class="card mb-3" *ngFor="let facility of data; let i = index;">
      <div class="card-header bg-primary">
        {{facility.Facility.Description}}
      </div>
      <div class="card-body card-block">
        <div class="material-item" *ngFor="let material of facility.Materials">
          <h5 class="card-title">
            {{material.DisplayName}} 
            <small class="text-muted" *ngIf="material.Tanks.length > 1">{{material.AvailableCapacityStr}} ({{material.AvailablePercentage}}%) / {{material.FreeCapacityStr}} / {{material.TotalCapacityStr}}</small>
          </h5>
          <div class="row tank-item-labels">
            <div class="col-md-3">
              {{_gearAppService.GearCommonLiterals.Tank}}
            </div>
            <div class="col-md-5 col-lg-4">
              {{_gearAppService.GearMonitorLiterals.CurrentInventory}}
            </div>
            <div class="col-xs-12 col-md-1 hide-md"></div>
            <div class="col-md-3">
              {{_gearAppService.GearMonitorLiterals.AvailableCapacity}}
            </div>
            <div class="col-md-1">
              {{_gearAppService.GearCommonLiterals.Status}}
            </div>
          </div>
          <div class="row tank-item" *ngFor="let tank of material.Tanks" [ngClass]="{
            'alert-danger': tank.Status === tankStatus.Error,
            'alert-warning': tank.Status === tankStatus.Maintenance
          }">
            <div class="col-xs-12 col-md-3">
              {{tank.DisplayName}}
            </div>
            <div class="col-xs-12 col-md-5 col-lg-4 tank-level">
              <div>{{tank.AvailableCapacityStr}}</div>
              <div class="progress">
                <div class="progress-bar" 
                  role="progressbar" 
                  [ngStyle]="{'background-color': colors.rgbToHexa(tank.Color)}" 
                  [style.width]="tank.AvailablePercentage+'%'">
                </div>
              </div>
              <div>{{tank.AvailablePercentage}}%</div>
            </div>
            <div class="col-xs-12 col-md-1 hide-md"></div>
            <div class="col-xs-8 col-md-3">
              <div class="label-mobile">{{_gearAppService.GearMonitorLiterals.AvailableCapacity}}</div>
              <div>{{tank.FreeCapacityStr}} ({{tank.FreePercentage}}%) / {{tank.TotalCapacityStr}}</div>
            </div>
            <div class="col-xs-4 col-md-1">
              <div class="label-mobile">{{_gearAppService.GearCommonLiterals.Status}}&nbsp;</div>
              <ng-template #tolTemplate>
                <p *ngFor="let error of tank.Errors;" [ngClass]="{'mb-0': tank.Errors.length === 1}">{{error}}</p>
              </ng-template>
              <span class="status-tooltip" triggers="click hover" 
                [tooltip]="(tank.Status === tankStatus.Error) 
                ? tolTemplate
                : (tank.Status === tankStatus.Maintenance) 
                  ? _gearAppService.GearCommonLiterals.InMaintenance 
                  : _appService.CoreCommonLiterals.Normal">
                <i class="fa" [ngClass]="{
                  'fa-check text-success': tank.Status === tankStatus.Normal,
                  'fa-exclamation-triangle text-danger': tank.Status === tankStatus.Error,
                  'fa-wrench text-warning': tank.Status === tankStatus.Maintenance
                }"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="listStatus === 0" class="text-center">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
  </div>
</div>